<template>
    <Row style="padding: 10px" :gutter="16">
        <Col span="7">
        <div id="left" class="layout">
            <div id="left-title">
                <div id="left-title-left">
                    <span>菜单配置树</span>
                </div>
                <div id="left-title-right">
                    <Button type="dashed" title="上移菜单" @click="upMenu" style="margin-right:10px;">
                        <Icon type="md-arrow-dropup-circle" size='18'/>
                    </Button>
                    <Button type="dashed" title="下移菜单" @click="downMenu" style="margin-right:10px;">
                        <Icon type="md-arrow-dropdown-circle" size='18'/>
                    </Button>

                    <Button type="dashed" title="添加菜单" @click="createMenu" style="margin-right:10px;">
                        <Icon type="ios-add-circle-outline" size='18' />
                    </Button>
                    <Button type="dashed" title="删除菜单" @click="deleteMenu">
                        <Icon type="md-trash" size='18' />
                    </Button>

                </div>
            </div>
            <div style="margin-top:20px;">
                <Input type="text" clearable v-model="searchItems.menuName" placeholder="请输入菜单名称" @keyup.enter.native="selectTreeNode" />
            </div>
            <Tree :data="treeData"
                  ref="menuTree"
                  style="margin: 20px 10px;"
                  @on-select-change="clickNode">
            </Tree>
        </div>
        </Col>
        <Col span="17">
        <div id="right" class="layout">
            <p id="right-title">
                菜单详情
            </p>
            <Form ref="formMenu" :model="formItemData" :rules="ruleInline" :label-width="80" style="margin:10px 30px;padding:15px 30px;">
                <Form-item label="父级菜单" prop="pId">
                    <Label style="font-size:16px;font-weight:700;">{{selectedNode}}</Label>
                    <input type="hidden" v-model="formItemData.pId" />
                </Form-item>
                <Form-item label="菜单名称" prop="menuName">
                    <Input type="textarea" v-model="formItemData.menuName" placeholder="请输入菜单名称" style="width:400px;" />
                </Form-item>
                <Form-item label="图标">
                    <svg class="icon">
                        <use :xlink:href="formItemData.menuIcon"></use>
                    </svg>
                    <lconLibrary :setIcon="setIcon" style="margin-left:15px;display:inline-block;" />
                </Form-item>

                <Form-item label="是否外联">
                    <i-Switch v-model="formItemData.isLink" @on-change="swithChange" />
                </Form-item>


                <Form-item label="动作内容" prop="menuUrl">
                    <Input type="textarea" v-model="formItemData.menuUrl" placeholder="请输入地址" style="width:400px;" />
                </Form-item>

                <Form-item label="排序" style="display:none;">
                    <InputNumber :max="10" :min="1" v-model="formItemData.sort"></InputNumber>
                </Form-item>

                <Form-item label="是否显示">
                    <Radio-group v-model="formItemData.isShow">
                        <Radio label="0">是</Radio>
                        <Radio label="1">否</Radio>
                    </Radio-group>
                </Form-item>
                <Form-item>
                    <Button type="primary" style="width:15%;" @click="handleSubmit">保存</Button>
                </Form-item>
            </Form>
        </div>
        </Col>
    </Row>
</template>

<script>
    import request from '@/utils/request'
    import lconLibrary from '@/components/IconLibrary'
    export default {
        name: 'menumanage',
        components: { lconLibrary },
        data() {
            return {
                treeData: [],
                searchItems: {
                    menuName: ''
                },
                selectedNode: '',
                formItemData: {
                    id: 0,
                    menuName: '',
                    menuIcon: '',
                    menuUrl: '',
                    isShow: '0',
                    pId: 0,
                    creator: parseInt(localStorage.getItem("userId")),
                    isLink: false,
                    sort: 1
                },
                ruleInline: {
                    pId: [
                        { type: 'number', required: true, message: '请选择父级菜单', trigger: 'change' }
                    ],
                    menuName: [
                        { required: true, message: '请填写菜单名称', trigger: 'blur' },
                        { type: 'string', max: 50, message: '输入不得大于50个字', trigger: 'blur' }
                    ],
                    menuUrl: [
                        { required: true, message: '请填写动作内容', trigger: 'blur' },
                        { type: 'string', max: 50, message: '输入不得大于50个字', trigger: 'blur' }
                    ]

                }
            }
        },
        methods: {
            initTreeData() {
                let component = this;
                request.get('/api/Menu/GetMenuTree').then(function (response) {
                    if (response.state == 0) {
                        component.$Notice.error({
                            title: '错误提示',duration: 3,
                            desc: "获取数据失败：" + response.errorMsg
                        });
                        return;
                    }
                    component.treeData = JSON.parse(response.data);
                    component.initTreeNode(component.treeData);
                }).catch(function (error) {
                })
            },
            initTreeNode(treeData) {
                for (let i = 0; i < treeData.length; i++) {
                    treeData[i].render = (h, { root, node, data }) => {
                        return h('span', [
                            h('svg', {
                                style: {
                                },
                                attrs: {
                                    class: "icon"
                                }
                            }, [h('use', {
                                attrs: {
                                    'xlink:href': `${data.menuIcon}`
                                }
                            })]),
                            h('span', {
                                style: {
                                    cursor: 'pointer',
                                    backgroundColor: node.node.selected ? "#d5e8fc" : "transparent"
                                },
                                attrs: {
                                    class: `ivu-tree-title`
                                },
                                on: {
                                    click: (e) => {
                                        if (!node.node.selected) {
                                            this.$refs.menuTree.handleSelect(node.nodeKey);

                                        }
                                    }
                                }
                            }), data.title]);

                    };
                    if (treeData[i].children && treeData[i].children.length > 0) {
                        this.initTreeNode(treeData[i].children);
                    }
                }
            },
            initFormData(component) {
                component.$refs["formMenu"].resetFields();
                component.selectedNode = '';
                component.formItemData.menuIcon = '';
                component.formItemData.id = 0;
                component.formItemData.isLink = false;
                component.formItemData.sort = 1;
                component.formItemData.isShow = "0";
            },
            handleSubmit() {

                this.$refs["formMenu"].validate((valid) => {

                    if (valid) {
                        let component = this;
                        request.post('/api/Menu/EditMenu', this.formItemData).then(function (response) {

                            if (response.state == 0) {
                                component.$Notice.error({
                                    title: '错误提示',duration: 3,
                                    desc: "保存失败：" + response.errorMsg
                                });
                                return;
                            }
                            //清空form规则检查
                            component.initFormData(component);
                            component.initTreeData();
                            component.$Notice.success({
                                title: '正确提示',duration: 3,
                                desc: '保存成功!'
                            });

                        }).catch(function (error) {
                        })
                    }
                })
            },
            clickNode() {
                let treeNode = this.$refs.menuTree.getSelectedNodes();
                if (treeNode.length <= 0 || treeNode[0].pId == 0) {
                    return;
                }

                this.formItemData.id = treeNode[0].value;
                this.formItemData.menuName = treeNode[0].menuName;
                this.formItemData.menuIcon = treeNode[0].menuIcon;
                this.formItemData.menuUrl = treeNode[0].menuUrl;
                this.formItemData.isShow = treeNode[0].isShow;
                this.formItemData.pId = treeNode[0].pId;
                this.selectedNode = treeNode[0].parentName;
                this.formItemData.isLink = treeNode[0].isLink;
                this.formItemData.sort = treeNode[0].sort;
                this.formItemData.createDate = treeNode[0].createDate;
            },
            createMenu() {
                let treeNode = this.$refs.menuTree.getSelectedNodes();
                if (treeNode.length <= 0) {
                    this.$Notice.error({
                        title: '错误提示',duration: 3,
                        desc: '请选中菜单添加的父菜单！'
                    });
                    return;
                }
                this.initFormData(this);
                this.selectedNode = treeNode[0].title;
                this.formItemData.pId = treeNode[0].value;
            },
            deleteMenu() {
                let treeNode = this.$refs.menuTree.getSelectedNodes();
                if (treeNode.length <= 0) {
                    this.$Notice.error({
                        title: '错误提示',duration: 3,
                        desc: '请选中要删除的菜单！'
                    });
                    return;
                }
                let component = this;
                if (treeNode[0].children.length > 0) {
                    this.$Modal.confirm({
                        title: "操作警告",
                        content: "当前节点下的子节点也将删除，是否继续操作？",
                        onOk() {
                            request.get('/api/Menu/DeleMenu', {
                                params: {
                                    menuId: treeNode[0].value
                                }
                            }).then(function (response) {

                                if (response.state == 0) {
                                    component.$Notice.error({
                                        title: '错误提示',duration: 3,
                                        desc: response.errorMsg
                                    });
                                    return;
                                }
                                component.initFormData(component);
                                component.initTreeData();

                            }).catch(function (error) {
                            })
                        },
                        onCancel() {
                        }
                    });
                } else {
                    this.$Modal.confirm({
                        title: "操作警告",
                        content: "当前节点下的子节点也将删除，是否继续操作？",
                        onOk() {
                            request.get('/api/Menu/DeleMenu', {
                                params: {
                                    menuId: treeNode[0].value
                                }
                            }).then(function (response) {
                                if (response.state == 0) {
                                    component.$Notice.error({
                                        title: '错误提示',duration: 3,
                                        desc: response.errorMsg
                                    });
                                    return;
                                }
                                component.initFormData(component);
                                component.initTreeData();

                            }).catch(function (error) {
                            })
                        },
                        onCancel() {
                        }
                    });
                }
            },
            setIcon(icon) {
                this.formItemData.menuIcon = icon;
            },
            swithChange(status) {

            },
            upMenu() {
                let treeNode = this.$refs.menuTree.getSelectedNodes();
                if (treeNode.length <= 0) {
                    this.$Notice.error({
                        title: '错误提示',duration: 3,
                        desc: '请选中要上移的菜单！'
                    });
                    return;
                }

                let component = this;
                request.get('/api/Menu/UpMenu', {
                    params: {
                        menuId: treeNode[0].value,
                        menuSort: treeNode[0].sort
                    }
                }).then(function (response) {

                    if (response.state == 0) {
                        component.$Notice.error({
                            title: '错误提示',duration: 3,
                            desc: "保存失败：" + response.errorMsg
                        });
                        return;
                    }
                    //清空form规则检查
                    component.initFormData(component);
                    component.initTreeData();
                }).catch(function (error) {
                })
            },
            downMenu() {
                let treeNode = this.$refs.menuTree.getSelectedNodes();
                if (treeNode.length <= 0) {
                    this.$Notice.error({
                        title: '错误提示',duration: 3,
                        desc: '请选中要下移的菜单！'
                    });
                    return;
                }

                let component = this;
                request.get('/api/Menu/DownMenu', {
                    params: {
                        menuId: treeNode[0].value,
                        menuSort: treeNode[0].sort
                    }
                }).then(function (response) {

                    if (response.state == 0) {
                        component.$Notice.error({
                            title: '错误提示',duration: 3,
                            desc: "保存失败：" + response.errorMsg
                        });
                        return;
                    }
                    //清空form规则检查
                    component.initFormData(component);
                    component.initTreeData();
                }).catch(function (error) {
                })
            },
            selectTreeNode() {
                this.initTreeData();
                let t;
                clearTimeout(t);
                let _self = this;
                t = setTimeout(() => { let item = _self.downSelect(_self.treeData); item.selected = true; }, 400);
            },
            downSelect(array) {
                let obj = {};
                for (let i = 0; i < array.length; i++) {
                    if (array[i].menuName.indexOf(this.searchItems.menuName) > -1) {
                        obj = array[i];
                    } else {
                        obj = this.downSelect(array[i].children);
                    }
                    if (obj) {
                        return obj;
                    }

                }
            }
        },
        created() {
            this.initTreeData();
        }
    }
</script>

<style scoped>
    .layout {
        background: #fff;
        border-radius: 8px;
        padding: 5px 10px;
    }

    #right {
    }

    #left-title {
        overflow: hidden;
        padding: 16px 20px;
        font-size: 16px;
        border-bottom: 1px solid #e8eaec;
    }

    #left-title-left {
        float: left;
    }

    #left-title-right {
        float: right;
    }

    #right-title {
        overflow: hidden;
        padding: 20px;
        font-size: 16px;
        border-bottom: 1px solid #e8eaec;
    }
    /*    .ivu-tree-title:hover {
        background-color: #eaf4fe;
    }*/
</style>
